import "firebase/auth";
import firebase from "./firebase.js";
import "firebase/firestore";
import "firebase/storage";
import "firebase/messaging";
import { app_singleton } from "../utility/app_singleton";

import EmailAuthProvider = firebase.auth.EmailAuthProvider;

let url = process.env.REACT_APP_URL_BACKEND ?? "";
if (url === "") {
    throw new Error("REACT_APP_URL_BACKEND is undefined");
}

const ThisUrl = "https://orser.it/"; //lo slash finale è importante

firebase.firestore().settings({
    experimentalForceLongPolling: true,
});
const db = firebase.firestore();

const storage = firebase.storage().ref();

class Fetch {
    static async getInfo(): Promise<string> {
        return new Promise(function (resolve, reject) {
            firebase.auth().onAuthStateChanged((user: any) => {
                if (user) {
                    resolve(user.uid);
                } else {
                    reject(Error("Not logged"));
                }
            });
        });
    }

    static getThisUrl() {
        return ThisUrl;
    }

    static getFirebase() {
        return firebase;
    }

    static getUrl() {
        return url;
    }

    static db() {
        return db;
    }

    static singOut() {
        firebase
            .auth()
            .signOut()
            .then(() => {
                window.location.href = "/";
            })
            .catch((error) => { });
    }

    static isAuth(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) resolve(true);
                else resolve(false);
            });
        });
    }

    public static send_notifica(id_cliente: string, stato: number) {
        return this.doFetch("/ordine/notifica", {
            method: "POST",
            body: {
                id_cliente: id_cliente,
                stato: stato,
            },
        });
    }

    /**
     * Performs an HTTP fetch request with the specified parameters.
     *
     * @param input - The resource that you wish to fetch.
     * @param obj - Optional configuration object.
     * @param obj.method - The HTTP method to use (e.g., "GET", "POST").
     * @param obj.header - Headers to include in the request.
     * @param obj.body - The body of the request, either as a plain object or a `BodyInit`.
     * @param obj.error_response_complete - If true, throws the complete response object on error.
     *
     * @returns A promise that resolves to the `Response` object.
     *
     * @throws Will throw an error if the response is not ok and `error_response_complete` is false.
     */
    public static async doFetch(
        input: RequestInfo,
        obj?: {
            method?: string;
            header?: Record<string, string>;
            body?: { [key: string]: any } | BodyInit;
            error_response_complete?: boolean;
        }
    ): Promise<Response> {
        const token = await this.getToken().catch((e) => "");

        if (obj === undefined) obj = {};

        if (!obj.header) obj.header = {};

        if (obj.error_response_complete === undefined)
            obj.error_response_complete = false;

        const is_multipart = obj.header["Content-Type"] === "multipart/form-data";

        obj.header["Authorization"] = "Bearer " + token;
        obj.header["Access-Control-Allow-Origin"] = "*";
        if (obj.header["Content-Type"] === undefined)
            obj.header["Content-Type"] = "application/json";
        else if (is_multipart) delete obj.header["Content-Type"];

        if (!obj.method) {
            obj.method = "GET";
        }

        input = url + input;

        const init: RequestInit = {
            headers: obj.header,
            body: is_multipart ? (obj.body as BodyInit) : JSON.stringify(obj.body),
            method: obj.method,
        };

        return fetch(input, init).then(async (res) => {
            if (res && "ok" in res && res.ok === true) return res;
            else if (obj !== undefined && obj.error_response_complete === true)
                throw res;
            else throw await res.json();
        });
    }

    static sendPrenotazione(
        idRistorante: string,
        data: Date,
        posti: number,
        share_email: boolean
    ) {
        return this.doFetch("/prenotazioni/" + idRistorante, {
            method: "POST",
            body: {
                data: data,
                posti: posti,
                share_email: share_email,
            },
        });
    }

    static getCurrentUser(): Promise<firebase.User> {
        //da sistemare perchè il login automatico nell'app non funziona
        return new Promise((resolve, reject) => {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) resolve(user);
                else reject(false);
            });
        });
    }

    static async registration(
        email: string,
        password: string,
        is_anonymus: boolean
    ) {
        if (is_anonymus) {
            const credential = EmailAuthProvider.credential(email, password);
            const user = await Fetch.getCurrentUser();
            return user.linkWithCredential(credential);
        }

        return firebase.auth().createUserWithEmailAndPassword(email, password);
    }

    static send_verify_email_and_snackbar() {
        return Fetch.doFetch("/utente/verify_email")
            .then(() => {
                app_singleton.event.snackbar.notify({
                    text: "Email di conferma inviata correttamente",
                    variant: "success",
                });
            })
            .catch((e) => {
                console.log(e);
                app_singleton.event.snackbar.notify({
                    text: "Troppi tentativi, riprova tra poco",
                    variant: "error",
                });
            });
    }

    static login(
        email: string,
        password: string
    ): Promise<firebase.auth.UserCredential> {
        return new Promise((resolve, reject) => {
            firebase
                .auth()
                .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
                .then(async () => {
                    resolve(
                        await firebase.auth().signInWithEmailAndPassword(email, password)
                    );
                })
                .catch(reject);
        });
    }

    static getToken() {
        return new Promise((resolve, reject) => {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    resolve(user.getIdToken(true));
                    return;
                } else {
                    reject({
                        response: {
                            status: 301,
                        },
                    });
                }
            });
        });
    }

    static create_anonymus_user() {
        return firebase.auth().onAuthStateChanged(async (user) => {
            if (user) {
                return user;
            } else {
                await firebase.auth().signInAnonymously();
            }
        });
    }

    static getOrdinazioneCassa(id_ristorante: string, id_tavolo: string) {
        return Fetch.doFetch("/ordinazione/cassa/" + id_ristorante, {
            method: "POST",
            body: {
                id_tavolo: id_tavolo,
            },
        });
    }

    static getOrdinazione(codice: string) {
        return Fetch.doFetch("/ordinazione", {
            method: "POST",
            body: {
                codice: codice,
            },
        });
    }

    static postBilling(uid: string, result: any) {
        return new Promise((resolve, reject) =>
            resolve(
                fetch(url + "/create-customer", {
                    method: "post",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        uid: uid, //fai un get sull'uid di chi è loggato
                        payment_method: result.paymentMethod.id,
                    }),
                }).then((res) => res.json())
            )
        );
    }

    static getInfoOnSub(sub: string) {
        return this.doFetch("/infostripe/info_sub", {
            method: "POST",
            body: {
                id_sub: sub,
            },
        });
    }

    static resetPassword(email: string) {
        return firebase.auth().sendPasswordResetEmail(email);
    }
}

export { db, storage, firebase, Fetch as default };

// Fetch.singOut();
